module.exports = __webpack_public_path__ + "img/Love-Me-compressor_tn.23227149.jpg";